import React from "react";
import moroccanOilBanner from "./../../../../../Images/Blog/moroccan_oil/Banner.png";

const MoroccanOilHairTreatmentImg = () => {
  return (
    <div className="blogImg-content">
      <img src={moroccanOilBanner} alt="moroccan Oil Banner" loading="lazy" />
    </div>
  );
};

export default MoroccanOilHairTreatmentImg;
